import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ThumbsUp = createSvgIcon(
  <path d="M11.189.086c1.527-.314 3.347.21 4.399 1.964 1.008 1.68.842 3.46.359 4.944a12.89 12.89 0 0 1-.874 2.008h7.798a1.126 1.126 0 0 1 1.096 1.383l-3 12.748c-.12.508-.573.867-1.095.867H0V9.002h5.35c.815-.44 1.488-.984 1.978-1.75.536-.836.92-2.04.92-3.874 0-1.826 1.483-2.992 2.941-3.292Zm-5.94 11.166h-3V21.75h3V11.252ZM7.5 21.75h11.48l2.47-10.498H11.136l1.023-1.704.097-.163c.56-.93 1.192-1.982 1.552-3.087.374-1.149.396-2.182-.15-3.092-.501-.836-1.306-1.062-2.015-.916-.779.16-1.145.664-1.145 1.088 0 2.153-.454 3.806-1.275 5.088a6.923 6.923 0 0 1-1.724 1.833V21.75Z" />,
  'ThumbsUp'
);

export { ThumbsUp };